var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "user_message_heard"
  }, [_c('Dropdown', {
    attrs: {
      "trigger": "click",
      "visible": _vm.dropdownVisible,
      "transfer": "",
      "transfer-class-name": "iw-user-dropdown-transfer",
      "placement": "bottom-end"
    },
    on: {
      "on-visible-change": _vm.setInitBizDate
    }
  }, [_c('div', {
    staticClass: "iw-user-trigger"
  }, [_c('div', {
    staticClass: "iw-user-info"
  }, [_c('p', {
    staticClass: "iw-user-name"
  }, [_vm._v(" " + _vm._s(_vm.user.userInfo && _vm.user.userInfo.unitName ? _vm.user.userInfo.userName : null) + " ")]), _c('p', {
    staticClass: "iw-user-unit"
  }, [_vm._v(" " + _vm._s(_vm.user.userInfo && !!_vm.user.userInfo.unitName ? _vm.user.userInfo.unitName : _vm.user.userInfo.mobile || _vm.user.userInfo.email) + " ")])]), _c('div', {
    staticClass: "iw-user-avatar"
  }, [_vm.userLogo !== _vm.userInitLogo ? _c('img', {
    staticClass: "iw-avatar-img",
    attrs: {
      "src": _vm.userLogo,
      "alt": ""
    }
  }) : _c('span', {
    staticClass: "iw-avatar-letter"
  }, [_vm._v(_vm._s((_vm.user.userInfo.userName || "?").charAt(0)))])]), _c('span', {
    staticClass: "material-symbols-outlined text-stone-400 text-[16px] iw-user-caret"
  }, [_vm._v("expand_more")])]), _c('div', {
    staticClass: "iw-user-dropdown",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('div', {
    staticClass: "iw-dropdown-header"
  }, [_c('div', {
    staticClass: "iw-dropdown-avatar"
  }, [_vm.userLogo !== _vm.userInitLogo ? _c('img', {
    staticClass: "iw-avatar-img",
    attrs: {
      "src": _vm.userLogo,
      "alt": ""
    }
  }) : _c('span', {
    staticClass: "iw-avatar-letter"
  }, [_vm._v(_vm._s((_vm.user.userInfo.userName || "?").charAt(0)))])]), _c('div', {
    staticClass: "iw-dropdown-identity"
  }, [_c('p', {
    staticClass: "iw-identity-name"
  }, [_vm._v(_vm._s(_vm.user.userInfo.userName))]), _c('div', {
    staticClass: "flex items-center gap-1.5 mt-0.5"
  }, [_c('span', {
    staticClass: "iw-identity-role"
  }, [_vm._v(_vm._s(_vm.user.userInfo.addressBookName))]), _vm.type.text ? _c('span', {
    staticClass: "iw-identity-tag",
    style: {
      background: _vm.type.pre ? _vm.type.pre + '20' : '',
      color: _vm.type.next || ''
    }
  }, [_vm._v(" " + _vm._s(_vm.type.text) + " ")]) : _vm._e()])])]), _vm.user.userInfo.unitName ? _c('div', {
    staticClass: "iw-dropdown-unit",
    on: {
      "click": _vm.replaceUnit
    }
  }, [_c('div', {
    staticClass: "iw-unit-icon"
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-500 text-[18px]"
  }, [_vm._v("hotel")])]), _c('div', {
    staticClass: "iw-unit-info"
  }, [_c('p', {
    staticClass: "iw-unit-label"
  }, [_vm._v($t("cdahrm4", "当前单位"))]), _c('p', {
    staticClass: "iw-unit-name"
  }, [_vm._v(_vm._s(_vm.user.userInfo.unitName))])]), _c('span', {
    staticClass: "material-symbols-outlined text-stone-300 text-[16px]"
  }, [_vm._v("unfold_more")])]) : _vm._e(), _c('div', {
    staticClass: "iw-dropdown-menu"
  }, [_c('div', {
    staticClass: "iw-dropdown-item",
    on: {
      "click": _vm.openMyInfo
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-500 text-[18px] w-6"
  }, [_vm._v("account_circle")]), _c('span', [_vm._v($t("a6u45a4", "个人信息"))])]), _vm.unitNumberBoo ? _c('div', {
    staticClass: "iw-dropdown-item",
    on: {
      "click": _vm.replaceUnit
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-500 text-[18px] w-6"
  }, [_vm._v("swap_horiz")]), _c('span', [_vm._v($t("arf11v4", "切换单位"))])]) : _vm._e(), _vm.showProtection ? _c('div', {
    staticClass: "iw-dropdown-item",
    on: {
      "click": _vm.protection
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-500 text-[18px] w-6"
  }, [_vm._v("shield")]), _c('span', [_vm._v($t("fcbw9t4", "登录保护"))])]) : _vm._e(), _c('div', {
    staticClass: "iw-dropdown-item",
    on: {
      "click": _vm.updatePassword
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-500 text-[18px] w-6"
  }, [_vm._v("key")]), _c('span', {
    class: _vm._updatePassword ? '' : 'contclick'
  }, [_vm._v(_vm._s(_vm.passwordMenuText))])]), _c('div', {
    staticClass: "iw-dropdown-item",
    on: {
      "click": _vm.openChangeLog
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-500 text-[18px] w-6"
  }, [_vm._v("history_edu")]), _c('span', [_vm._v($t("dev07i4", "更新日志"))])])]), _c('div', {
    staticClass: "iw-dropdown-footer",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onLogout.apply(null, arguments);
      },
      "touchend": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onLogout.apply(null, arguments);
      }
    }
  }, [_c('span', {
    staticClass: "material-symbols-outlined text-stone-500 text-[18px]"
  }, [_vm._v("logout")]), _c('span', [_vm._v($t("iifi5w4", "退出登录"))])])])]), _c('UpdatePassword', {
    ref: "updatePassword"
  }), _c('InitPassword', {
    ref: "initPasswordRef"
  }), _c('MyInfo', {
    ref: "myInfo",
    attrs: {
      "visible": _vm.myInfo.visible
    },
    on: {
      "close": _vm.close
    }
  }), _c('Protection', {
    ref: "protection",
    attrs: {
      "closeable": _vm.closeable
    },
    on: {
      "validSuccess": _vm.validSuccess,
      "validCancel": _vm.validCancel
    }
  }), _c('ValidMFA', {
    ref: "validMFA"
  }), _c('TipModal', {
    ref: "tipModal"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };